/*global FakeCation, document, FB */
(function (FC) {
  "use strict";

  const HOST = 'https://graph.facebook.com/';
  const VERSION = 'v2.5/';
  var fb = {};

  fb.getLoginStatus = function () {
    return new Promise(function (resolve, reject) {
      FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
          var uid = response.authResponse.userID;
          var accessToken = response.authResponse.accessToken;
          resolve({
            uid: response.authResponse.userID,
            accessToken: response.authResponse.accessToken
          });
        } else {
          reject(response);
        }
      });
    });
  };

  fb.login = function (opts) {
    return new Promise(function (resolve, reject) {
      FB.login(function (response) {
        if (response.authResponse) {
          resolve(response);
        } else {
          reject(response);
        }
      }, opts);
    });
  };

  fb.uploadPhoto = function (caption, imageBlob, accessToken) {
    return new Promise(function (resolve, reject) {
      var formData = new FormData(),
          xhr = new XMLHttpRequest();
      formData.append("attachment", imageBlob);
      formData.append("access_token", accessToken);
      formData.append("caption", caption);
      xhr.open("POST",HOST+VERSION+'me/photos');
      xhr.send(formData);
      xhr.addEventListener('load', resolve);
      xhr.addEventListener('error', reject);
      xhr.addEventListener('abort', reject);
    });
  };

  FC.fb = fb;

}(FakeCation));
